import { c as _c } from "react-compiler-runtime";
import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const TOOLTIP_PROVIDER_COMPONENT_NAME = 'TooltipProvider';
export function TooltipProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = /*#__PURE__*/_jsx(BaseTooltip.Provider, {
      delay: 300,
      timeout: 400,
      children: children
    });
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
TooltipProvider.displayName = TOOLTIP_PROVIDER_COMPONENT_NAME;